import React from 'react';
import {DeliveryInformation} from './shopdetail/index';
import { useLocation } from 'react-router-dom';




const Order = () => {
  const location = useLocation();
  
  return (
    <div>
        {location.state.ctList.length > 0 && <DeliveryInformation ctList={location.state.ctList} /> }
    </div>
  )
}

export default Order
